import { render } from "./InputTextarea.vue?vue&type=template&id=6044e723&scoped=true"
import script from "./InputTextarea.vue?vue&type=script&lang=js"
export * from "./InputTextarea.vue?vue&type=script&lang=js"

import "./InputTextarea.vue?vue&type=style&index=0&id=6044e723&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6044e723"]])

export default __exports__